import { render } from "./LabelStaticRegions.vue?vue&type=template&id=bf255508"
import script from "./LabelStaticRegions.vue?vue&type=script&lang=js"
export * from "./LabelStaticRegions.vue?vue&type=script&lang=js"

import "./LabelStaticRegions.vue?vue&type=style&index=0&id=bf255508&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__